import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { List } from 'foundations-components/transitional/components/List';
import { getI18nText } from 'pricing-pages-lib/utils/languageUtils';
import { ExpandingFAQ } from 'pricing-pages-ui-components/frequentlyAskedQuestions/FrequentlyAskedQuestions';
import { useState } from 'react';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { TRACKING_SOURCES } from '../../constants/tracking/TrackingSources';
import { useDisplayedCurrencyCode } from '../../hooks/useCurrencies';
import { trackClickedLink, trackFaqInteraction } from '../../utils/tracking/trackingEventUtils';
import LinkWrapper from '../common/LinkWrapper';
import SkeletonWrappedFormattedMessage from '../common/i18n/SkeletonWrappedFormattedMessage';
import { TranslationsContext } from './Faq';
import { jsx as _jsx } from "react/jsx-runtime";
const Question = ({
  questionKey,
  getHref,
  onClick,
  onQuestionClick = () => {},
  getPassedInOptions = () => ({}),
  isJSX = true,
  isExternalLink = true
}) => {
  const href = getHref && getHref();
  const passedInOptions = getPassedInOptions && getPassedInOptions();
  const [isQuestionOpen, setIsQuestionOpen] = useState(false);
  const currencyCode = useDisplayedCurrencyCode();
  const handleClickQuestion = () => {
    trackFaqInteraction({
      action: isQuestionOpen ? 'closed' : 'opened',
      value: getI18nText(`faq.${questionKey}.question`, {
        locale: 'en-us'
      }),
      questionKey
    });
    setIsQuestionOpen(prev => !prev);
    onQuestionClick();
  };
  const handleClickLink = () => {
    if (onClick) {
      onClick();
    } else {
      trackClickedLink({
        url: href || '',
        type: isExternalLink ? 'external' : 'internal',
        trackingSource: TRACKING_SOURCES.FAQ,
        value: questionKey
      });
    }
  };
  const QuestionLink = ({
    children
  }) => {
    if (isExternalLink) {
      return /*#__PURE__*/_jsx(LinkWrapper, {
        external: isExternalLink,
        href: href,
        onClick: handleClickLink,
        children: children
      });
    }
    return /*#__PURE__*/_jsx(UIRouterLink, {
      to: href || '/',
      onClick: handleClickLink,
      children: children
    });
  };
  const questionTitle = /*#__PURE__*/_jsx(FormattedMessage, {
    message: `faq.${questionKey}.question`
  });
  const questionContent = isJSX ? /*#__PURE__*/_jsx(SkeletonWrappedFormattedMessage, {
    MessageComponent: FormattedJSXMessage,
    translationsContext: TranslationsContext,
    message: `faq.${questionKey}.answer_jsx`,
    options: Object.assign({
      currencyCode
    }, passedInOptions),
    elements: {
      Link: QuestionLink,
      FormattedNumber,
      UIList: List,
      UILink: LinkWrapper,
      Br: () => /*#__PURE__*/_jsx("br", {}),
      div: _ref => {
        let {
            children
          } = _ref,
          rest = _objectWithoutPropertiesLoose(_ref, _excluded);
        return /*#__PURE__*/_jsx(View, Object.assign({}, rest, {
          children: children
        }));
      },
      Bold: ({
        children
      }) => /*#__PURE__*/_jsx(Text, {
        as: "strong",
        typography: "heading-50",
        children: children
      })
    }
  }) : /*#__PURE__*/_jsx(SkeletonWrappedFormattedMessage, {
    translationsContext: TranslationsContext,
    message: `faq.${questionKey}.answer`
  });
  return /*#__PURE__*/_jsx(ExpandingFAQ, {
    Title: questionTitle,
    Content: questionContent,
    onExpandedChange: handleClickQuestion
  });
};
export default Question;